import React, { useEffect, useState } from "react";
// import * as Yup from "yup";
import { getCategories } from "../../api/categoryService";
import { getCoupons } from "../../api/couponService";
import { useNavigate } from "react-router-dom";
import { getErrorMessage } from "../../utils/errorHandler";

export default function ProductForm({
  onSubmit,
  loading = false,
  backendErrors = {},
  initialData = null,
  isEdit = false,
}) {
  const navigate = useNavigate();
  const initialState = {
    productName: "",
    categoryId: "",

    // NEW FIELDS
    heading: "",
    productWeight: "",
    length: "",
    width: "",
    height: "",
    thickness: "",


    // CHECKBOXES
    isFeatured: false,
    newArrival: false,

    // TEXT
    highlight: "",
    productDescription: "",
    durability: "",
    previewtext: "",

    // SEO
    metaTitle: "",
    metaKeywords: "",
    metaDescription: "",
    metaRobots: "index,follow",

    coupons: "",
    status: "",
  };
  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [categories, setCategories] = useState([]);
  const [coupons, setCoupons] = useState([]);

  useEffect(() => {
    if (initialData) {
      setFormData({
        productName: initialData.productName || "",
        productName: initialData.productName || "",
        categoryId: initialData.categoryId?._id || initialData.categoryId || "",
        heading: initialData.heading || "",
        productWeight: initialData.productWeight || "",
        length: initialData.length || "",
        width: initialData.width || "",
        height: initialData.height || "",
        thickness: initialData.thickness || "",
        isFeatured: initialData.isFeatured || false,
        newArrival: initialData.newArrival || false,
        highlight: initialData.highlight || "",
        productDescription: initialData.productDescription || "",
        durability: initialData.durability || "",
        previewtext: initialData.previewtext || "",
        metaTitle: initialData.metaTitle || "",
        metaKeywords: Array.isArray(initialData.metaKeywords)
          ? initialData.metaKeywords.join(", ")
          : initialData.metaKeywords || "",
        metaDescription: initialData.metaDescription || "",
        metaRobots: initialData.metaRobots || "index,follow",
        coupons: initialData.coupons?._id || initialData.coupons || "",
        status: initialData.status || "",
      });
    }
  }, [initialData]);

  const fetchCategories = async () => {
    try {
      const response = await getCategories();
      setCategories(response?.data || []);
    } catch (error) {
      alert(getErrorMessage(error));
    }
  };
  const fetchCoupons = async () => {
    try {
      const response = await getCoupons();
      setCoupons(response.data || []);
    } catch (error) {
      alert(getErrorMessage(error));
    }
  };
  useEffect(() => {
    fetchCategories();
    fetchCoupons();
  }, []);
  // const validationSchema = Yup.object({
  //   productName: Yup.string()
  //     .trim()
  //     .max(50, "Product name must be at most 50 characters")
  //     .required("Product name is required"),
  //   categoryId: Yup.string().required("Category is required"),
  //   highlight: Yup.string().required("Highlight is required"),
  //   durability: Yup.string().required("Durability is required"),
  //   productDescription: Yup.string().required(
  //     "Product description is required",
  //   ),
  //   metaTitle: Yup.string().required("Meta title is required"),
  //   metaKeywords: Yup.string().required("Meta keywords are required"),
  //   metaDescription: Yup.string().required("Meta description is required"),
  //   coupons: Yup.string().required("Coupon is required"),
  // });
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setErrors({});

      const payload = {
        productName: formData.productName,
        categoryId: formData.categoryId,
        heading: formData.heading,
        productWeight: formData.productWeight,
        length: formData.length,
        width: formData.width,
        height: formData.height,
        thickness: formData.thickness,
        isFeatured: formData.isFeatured,
        newArrival: formData.newArrival,
        highlight: formData.highlight,
        productDescription: formData.productDescription,
        durability: formData.durability,
        preview: formData.previewtext,
        metaTitle: formData.metaTitle,
        metaKeywords: formData.metaKeywords
          .split(",")
          .map((item) => item.trim())
          .filter(Boolean),
        metaDescription: formData.metaDescription,
        metaRobots: formData.metaRobots,
        coupons: formData.coupons ? [formData.coupons] : [],
        ...(isEdit && { status: formData.status }),
      };
      await onSubmit(payload);
      setSuccessMessage("Product Added Successfully");
      setFormData(initialState);
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
    } catch (error) {
      if (error.inner) {
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
      }
    }
  };
  return (
    <div className="container">
      <div className="card shadow border-0">
        {/* SUCCESS MESSAGE */}
        {successMessage && (
          <div className="alert alert-success">{successMessage}</div>
        )}
        <form onSubmit={handleSubmit}>
          {/* PRODUCT NAME */}
          <div className="row">
            <div className="col-md-12 mb-2 h80">
              <label className="form-label">
                Product Name<span className="error">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${errors.productName || backendErrors?.productName
                  ? "is-invalid"
                  : ""
                  }`}
                name="productName"
                value={formData.productName}
                onChange={handleChange}
                maxLength={50}
              />
              {errors.productName && (
                <div className="invalid-feedback">{errors.productName}</div>
              )}
              {!errors.productName && backendErrors?.productName && (
                <div className="invalid-feedback d-block">
                  {backendErrors.productName}
                </div>
              )}
            </div>
          </div>

          {/* PRODUCT DESCRIPTION */}
          <div className="row">
            <div className="col-md-12 mb-2 h120">
              <label className="form-label">
                Product Description
                <span className="error">*</span>
              </label>
              <textarea
                rows="4"
                className={`form-control ${errors.productDescription || backendErrors?.productDescription
                  ? "is-invalid"
                  : ""
                  }`}
                name="productDescription"
                value={formData.productDescription}
                onChange={handleChange}
              />
              {errors.productDescription && (
                <div className="invalid-feedback">
                  {errors.productDescription}
                </div>
              )}
              {!errors.productDescription &&
                backendErrors?.productDescription && (
                  <div className="invalid-feedback d-block">
                    {backendErrors.productDescription}
                  </div>
                )}
            </div>
          </div>

         
          
          {/* CATEGORY + COUPON */}
          <div className="row">
            {/* CATEGORY */}
            <div className="col-md-6 mb-2 h80">
              <label className="form-label">
                Category<span className="error">*</span>
              </label>
              <select
                className={`form-select ${errors.categoryId || backendErrors?.categoryId
                  ? "is-invalid"
                  : ""
                  }`}
                name="categoryId"
                value={formData.categoryId}
                onChange={handleChange}
              >
                <option value="">Select Category</option>
                {categories.map((category) => (
                  <option key={category._id} value={category.slug}>
                    {category.slug}
                  </option>
                ))}
              </select>
              {errors.categoryId && (
                <div className="invalid-feedback">{errors.categoryId}</div>
              )}
              {!errors.categoryId && backendErrors?.categoryId && (
                <div className="invalid-feedback d-block">
                  {backendErrors.categoryId}
                </div>
              )}
            </div>
            {/* COUPONS */}
            <div className="col-md-6 mb-2 h80">
              <label className="form-label">
                Coupons<span className="error">*</span>
              </label>
              <select
                className={`form-select ${errors.coupons || backendErrors?.coupons ? "is-invalid" : ""
                  }`}
                name="coupons"
                value={formData.coupons}
                onChange={handleChange}
              >
                <option value="">Select Coupon</option>

                {coupons?.map((coupon) => (
                  <option key={coupon._id} value={coupon._id}>
                    {coupon._id}
                  </option>
                ))}
              </select>
              {errors.coupons && (
                <div className="invalid-feedback">{errors.coupons}</div>
              )}
              {!errors.coupons && backendErrors?.coupons && (
                <div className="invalid-feedback d-block">
                  {backendErrors.coupons}
                </div>
              )}
            </div>
          </div>
          {/* CHECKBOXES */}
          <div className="row align-items-center mt-3">
            <div className="col-md-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="isFeatured"
                  checked={formData.isFeatured}
                  onChange={handleChange}
                />
                <label className="form-check-label">Featured Product</label>
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="newArrival"
                  checked={formData.newArrival}
                  onChange={handleChange}
                />
                <label className="form-check-label">New Arrival</label>
              </div>
            </div>

            <div className="col-md-6 h120">
              <label className="form-label">
                Preview Text<span className="error">*</span>
              </label>
              <textarea
                rows={3}
                className={`form-control ${errors.previewtext || backendErrors?.previewtext
                  ? "is-invalid"
                  : ""
                  }`}
                name="previewtext"
                value={formData.previewtext}
                onChange={handleChange}
              />

              {errors.previewtext && (
                <div className="invalid-feedback">{errors.previewtext}</div>
              )}

              {!errors.previewtext && backendErrors?.previewtext && (
                <div className="invalid-feedback d-block">
                  {backendErrors.previewtext}
                </div>
              )}
            </div>
          </div>

          {/* HIGHLIGHT + DURABILITY */}
          <div className="row">
            {/* HIGHLIGHT */}

            <div className="col-md-6 mb-2 h120">
              <label className="form-label">
                Highlight<span className="error">*</span>
              </label>
              <textarea
                rows="4"
                className={`form-control ${errors.highlight || backendErrors?.highlight
                  ? "is-invalid"
                  : ""
                  }`}
                name="highlight"
                value={formData.highlight}
                onChange={handleChange}
              />
              {errors.highlight && (
                <div className="invalid-feedback">{errors.highlight}</div>
              )}
              {!errors.highlight && backendErrors?.highlight && (
                <div className="invalid-feedback d-block">
                  {backendErrors.highlight}
                </div>
              )}
            </div>
            {/* DURABILITY */}
            <div className="col-md-6 mb-2 h120">
              <label className="form-label">
                Durability<span className="error">*</span>
              </label>
              <textarea
                rows="4"
                className={`form-control ${errors.durability || backendErrors?.durability
                  ? "is-invalid"
                  : ""
                  }`}
                name="durability"
                value={formData.durability}
                onChange={handleChange}
              />
              {errors.durability && (
                <div className="invalid-feedback">{errors.durability}</div>
              )}
              {!errors.durability && backendErrors?.durability && (
                <div className="invalid-feedback d-block">
                  {backendErrors.durability}
                </div>
              )}
            </div>
          </div>
          {isEdit && (
            <div className="row">
              <div className="col-md-6 mt-3 h80">
                <label className="form-label">
                  Status<span className="error">*</span>
                </label>

                <select
                  className={`form-select ${errors.status || backendErrors?.status ? "is-invalid" : ""
                    }`}
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                >
                  <option value="ACTIVE">Active</option>
                  <option value="INACTIVE">Inactive</option>
                </select>

                {errors.status && (
                  <div className="invalid-feedback">{errors.status}</div>
                )}

                {!errors.status && backendErrors?.status && (
                  <div className="invalid-feedback d-block">
                    {backendErrors.status}
                  </div>
                )}
              </div>
            </div>
          )}
          {/* Heading */}
          <h6 className="mt-5">packageInfo</h6>
          <div className="row">
            <div className="col-md-3 mb-2">
              <label> width </label>
              <input
                type="text"
                className="form-control"
                name="width"
                value={formData.width}
                onChange={handleChange}
              />
            </div>

           <div className="col-md-3 mb-2">
              <label>height</label>
              <input
                type="text"
                className="form-control"
                name="height"
                value={formData.height}
                onChange={handleChange}
              />
            </div>
             <div className="col-md-3 mb-2">
              <label>length</label>
              <input
                type="text"
                className="form-control"
                name="length"
                value={formData.length}
                onChange={handleChange}
              />
            </div>
             <div className="col-md-3 mb-2">
              <label>thinkess</label>
              <input
                type="text"
                className="form-control"
                name="Thinkess"
                value={formData.Thinkess}
                onChange={handleChange}
              />
            </div>
             <div className="col-md-3 mb-2">
              <label> productWeight</label>
              <input
                type="text"
                className="form-control"
                name="weight"
                value={formData.weight}
                onChange={handleChange}
              />
            </div>
          
          
            
          </div>

          {/* SEO */}
          <div className="row">
            <h6 className="mt-5">SEO Data</h6>
            {/* META TITLE */}
            <div className="col-md-12 mb-2 h80">
              <label className="form-label">
                Meta Title<span className="error">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${errors.metaTitle || backendErrors?.metaTitle
                  ? "is-invalid"
                  : ""
                  }`}
                name="metaTitle"
                value={formData.metaTitle}
                onChange={handleChange}
              />
              {errors.metaTitle && (
                <div className="invalid-feedback">{errors.metaTitle}</div>
              )}
              {!errors.metaTitle && backendErrors?.metaTitle && (
                <div className="invalid-feedback d-block">
                  {backendErrors.metaTitle}
                </div>
              )}
            </div>
            {/* META KEYWORDS */}
            <div className="col-md-12 mb-2 h80">
              <label className="form-label">
                Meta Keywords
                <span className="error">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${errors.metaKeywords || backendErrors?.metaKeywords
                  ? "is-invalid"
                  : ""
                  }`}
                name="metaKeywords"
                value={formData.metaKeywords}
                onChange={handleChange}
              />
              {errors.metaKeywords && (
                <div className="invalid-feedback">{errors.metaKeywords}</div>
              )}
              {!errors.metaKeywords && backendErrors?.metaKeywords && (
                <div className="invalid-feedback d-block">
                  {backendErrors.metaKeywords}
                </div>
              )}
            </div>
            {/* META DESCRIPTION */}
            <div className="col-md-12 mb-2 h120">
              <label className="form-label">
                Meta Description
                <span className="error">*</span>
              </label>
              <textarea
                rows="4"
                className={`form-control ${errors.metaDescription || backendErrors?.metaDescription
                  ? "is-invalid"
                  : ""
                  }`}
                name="metaDescription"
                value={formData.metaDescription}
                onChange={handleChange}
              />
              {errors.metaDescription && (
                <div className="invalid-feedback">{errors.metaDescription}</div>
              )}
              {!errors.metaDescription && backendErrors?.metaDescription && (
                <div className="invalid-feedback d-block">
                  {backendErrors.metaDescription}
                </div>
              )}
            </div>
          </div>
          {/* BUTTONS */}
          <div className="d-flex justify-content-end gap-2 mt-3">
            <button type="submit" className="btn btn-primary">
              {loading ? "Saving..." : isEdit ? "Update Product" : "Submit"}
            </button>

            <button
              type="button"
              className="btn"
              style={{ backgroundColor: "#032B4D", color: "#fff" }}
              onClick={() => navigate("/Product")}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
